<template>
  <div>
    <div class="banner-container" id="top">
      <img class="banner" :src="bannerLink" alt="" srcset="" />
      <section class="container total-width banner-text">
        <!-- 公司介绍 -->
        <section class="survey">
          <h1 class="company-title" id="info">集团介绍</h1>
          <h1 class="company-sub-title" id="info">Group Introduction</h1>
          <section class="company-text">
            <section>
              <p>
                库课科技集团股份有限公司（以下简称库课科技集团）创立于2007年，是一家集数智内容
                研发、应用及产教融合为一体的教育科技企业。
              </p>
              <p>
                2021年4月6日，库课科技集团（股票代码：872898）从新三板摘牌，现为省级主板上市
                重点后备企业。
              </p>
              <p>
                秉持“科技引领”发展理念，库课科技集团下设：数智出版研究院、数智教学研究院、数智商务研究院、AI技术研究院、库课数智商学院、产教融合研究院等部门。
              </p>
              <p>
                2025年底，集团在职员工2000余人，共有软著、著作权、专利2500余项，课程服务覆盖
                全国31个省区市，学习体验中心超300所，年培训学员逾百万人次，年销售图书超千万册。
                集团先后荣获“全国教育榜样集团”“新华网AI+教育融合发展案例”“民办教育先进单位”
                “综合影响力标杆教育集团”“口碑影响力职业教育品牌”等荣誉。
              </p>
              <p>
                集团先后被授予“国家级科技型中小企业”“省级专精特新企业”“省级工程研发中心”“市
                级数字经济重点企业”“市级科技小巨人企业”等资质。
              </p>
              <p>
                未来，库课科技集团将紧跟国家战略规划，深耕职业教育领域，致力成为“学历提升及高质
                量就业培训第一品牌”。
              </p>
            </section>
          </section>
        </section>
      </section>
    </div>

    <!-- 品牌起源 -->
    <section class="brand-box">
      <section class="brand total-width">
        <h1 class="box-title" id="origin">品牌起源</h1>
        <p class="box-sub-title">起源于天一，发展为库课</p>
        <img class="img" :src="brandLink" alt="" />
      </section>
    </section>

    <!-- 企业文化 -->
    <section class="culture-box">
      <section class="culture total-width">
        <h1 class="white-title" id="culture">企业文化</h1>
        <section class="content mt-[60px]">
          <section v-for="item in cultureArr" :key="item.src" class="per white">
            <img class="icon" :src="item.link" alt="" />
            <p class="title mt-[40px]">【{{ item.title }}】</p>
            <p class="detail mt-[20px]" v-html="item.content"></p>
          </section>
        </section>
      </section>
    </section>

    <!-- 集团战略 -->
    <section class="brand-box">
      <section class="brand total-width">
        <h1 class="box-title" id="strategy">集团战略</h1>
        <p class="box-sub-title">125战略</p>
        <img class="img" :src="groupStrategyLink" alt="" />
      </section>
    </section>

    <!-- 数字库课 -->
    <section class="digit-box">
      <section class="culture total-width">
        <h1 class="white-title" id="digit">数字库课</h1>
        <section class="content mt-[60px]">
          <section
            v-for="item in digitArr"
            :key="item.src"
            class="digit-per white"
          >
            <img class="icon" :src="item.link" alt="" />
          </section>
        </section>
      </section>
    </section>

    <!-- 企业荣誉 -->
    <section class="honor-box">
      <section class="total-width">
        <h1 class="black-title" id="honor">企业荣誉</h1>
        <div class="swiper mt-[60px]">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in honorList" :key="index">
              <img
                :src="item"
                style="width: 372px; height: 257px; object-fit: cover"
              />
            </swiper-slide>
          </swiper>
        </div>
      </section>
    </section>
    <!-- 品牌历程 -->
    <section class="course-box">
      <section class="course total-width">
        <h1 id="course" class="black-title">品牌历程</h1>
        <div class="swiper mt-[60px] course-swiper">
          <swiper ref="mySwiper2" :options="swiperOptions2">
            <swiper-slide v-for="(item, index) in courseList" :key="index">
              <div @mouseover="courseStatus = index">
                <img v-show="courseStatus !== index" :src="item.link" />
                <img v-show="courseStatus === index" :src="item.activeLink" />
              </div>
            </swiper-slide>
            <div
              class="swiper-button-prev swiper-button-black"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next swiper-button-black"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </section>
      <video
        autoplay="autoplay"
        loop="loop"
        id="video"
        x-webkit-airplay="true"
        webkit-playsinline="true"
        muted
      >
        <source src="@/assets/video/lizi.mp4" type="video/mp4" />
      </video>
    </section>
    <!-- 社会责任 -->
    <section class="responsibility-box">
      <section class="responsibility total-width">
        <h1 class="white-title" id="responsibility">社会责任</h1>
        <section class="flex">
          <section class="le fuk">
            <div class="content">
              <div class="title">
                <p class="le">最新资讯 NEWS</p>
                <!--                <p class="ri">信息动态共享 · 新闻记事历历在目</p>-->
              </div>
              <!--              <p>-->
              <!--                <a v-for="(item, index) in news" :key="index" target="_blank">{{-->
              <!--                  item.title-->
              <!--                }}</a>-->
              <!--              </p>-->

              <div class="donation-list">
                <!-- 2025年 -->
                <div class="donation-item">
                  <div class="year">2025</div>
                  <div class="details">
                    <p>向黄帝故里基金会捐赠现金2万元</p>
                  </div>
                </div>

                <!-- 2024年 -->
                <div class="donation-item">
                  <div class="year">2024</div>
                  <div class="details">
                    <p>向黄帝故里基金会捐赠现金5万元</p>
                    <p>向黔西市慈善捐赠现金2万元</p>
                  </div>
                </div>

                <!-- 2023年 -->
                <div class="donation-item">
                  <div class="year">2023</div>
                  <div class="details">
                    <p>
                      向社区慈善基金、爱心助学、99公益节等慈善机构累计捐赠5万余元
                    </p>
                    <p>
                      向中华思源工程捐赠价值30万元救灾物资用于河北特大洪水灾害
                    </p>
                    <p>向郑州大学教育发展基金会捐款5万元</p>
                  </div>
                </div>

                <!-- 2022年 -->
                <div class="donation-item">
                  <div class="year">2022</div>
                  <div class="details">
                    <p>
                      向河南省学生安全救助基金会捐赠5万元现金，资助贫困大学生
                    </p>
                    <p>向河南省铭刻雕刻基金会捐赠现金10万元</p>
                    <p>
                      向经八路街道办事处、荥阳慈善协会等机构捐赠价值5万余元现金及物品
                    </p>
                  </div>
                </div>

                <!-- 2021年 -->
                <div class="donation-item">
                  <div class="year">2021</div>
                  <div class="details">
                    <p>
                      向中华思源工程基金会捐款现金101.5万元，用于郑州“7.20”暴雨灾区重建和资助贫困学生
                    </p>
                    <p>
                      向郑州慈善总会、红十字会捐赠价值10余万现金及物品用于抗疫
                    </p>
                    <p>
                      向北京世华公益基金会捐赠50万元现金，助力贫困学生完成学业
                    </p>
                    <p>
                      向河南省公益文化基金会第四届“奔跑的通知书”助学活动捐款5万元，资助贫困大学生
                    </p>
                  </div>
                </div>

                <!-- 2020年 -->
                <div class="donation-item">
                  <div class="year">2020</div>
                  <div class="details">
                    <p>
                      冠名“库课文化杯”第29届世界记忆锦标赛郑州赛区，关注脑力运动发展
                    </p>
                    <p>
                      疫情期间累计向社会捐赠价值226余万元课程、物资及现金，用于抗疫救灾及资助学生
                    </p>
                  </div>
                </div>

                <!-- 2019年 -->
                <div class="donation-item">
                  <div class="year">2019</div>
                  <div class="details">
                    <p>
                      向黄帝故里基金会捐赠50万元现金，用于关爱家庭教育公益活动
                    </p>
                    <p>集团开展“助力中考 爱心送水”公益活动</p>
                  </div>
                </div>

                <!-- 2018年 -->
                <div class="donation-item">
                  <div class="year">2018</div>
                  <div class="details">
                    <p>
                      向郑州市大学生创业就业慈善基金会捐赠价值30万元图书，助力大学生创业就业
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="ri">
            <div>
              <div class="btn-box">
                <button
                  class="btn-society white"
                  :class="['activeBtn', 'riBtn']"
                >
                  {{ societyOne }}
                </button>
              </div>
              <div class="mt-[30px]">
                <img :src="societyImgOne" alt="" />
              </div>

              <div class="btn-box mt-[20px]">
                <button
                  class="btn-society white"
                  :class="['activeBtn', 'riBtn']"
                >
                  {{ societyTwo }}
                </button>
              </div>
              <div class="mt-[30px]">
                <img :src="societyImgTwo" alt="" />
              </div>
            </div>
          </section>
        </section>
      </section>
    </section>
    <!-- 团队风采 -->
    <!--    <section class="staffstyle-box">-->
    <!--      <section class="staffstyle total-width">-->
    <!--        <h1 id="staffstyle">员工风采</h1>-->
    <!--        <p class="staffstyle_tab">-->
    <!--          <span @click="staffstyleTab('team')" :class="staffstyleActive==='team'&&'staff_active'">团队风采</span>-->
    <!--          <span @click="staffstyleTab('person')" :class="staffstyleActive==='person'&&'staff_active'">个人风采</span>-->
    <!--        </p>-->
    <!--        <div class="staffstyle_tab_content">-->
    <!--          <ul class="tab_ul">-->
    <!--            <li -->
    <!--            v-for="(item,index) in indexStaffStyle[staffstyleActive]" -->
    <!--            :key="item.id"-->
    <!--            @click="imgActive=index"-->
    <!--            :class="index===imgActive&&'img_active'"-->
    <!--            >-->
    <!--              <img class="img_default" :src="item.img" alt="">-->
    <!--              <div :class="index!==imgActive&&'img_bg'">-->
    <!--                <img v-if="index===3&&staffstyleActive==='team'" src="@/assets/images/staffstyle/team_4_index_small.png" alt="">-->
    <!--                <span>{{item.name}}</span>-->
    <!--              </div>-->
    <!--              <div :class="index===imgActive&&'info'">-->
    <!--                <p class="info_name">{{item.name}}</p>-->
    <!--                <span class="info_line"></span>-->
    <!--                <p class="info_glory">{{item.glory}}</p>-->
    <!--              </div>-->
    <!--            </li>-->
    <!--          </ul>-->
    <!--          <p class="look_allStyle">-->
    <!--            <span @click="$router.push({path:'company/allStaffStyle'})">查看全部员工风采</span>-->
    <!--          </p>-->
    <!--        </div>-->
    <!--      </section>-->
    <!--    </section>-->
  </div>
</template>
<script>
import { companyData } from "@/common/util/data";
import metaInfo from "@/common/util/metaInfo";
import { indexStaffStyle } from "@/common/util/staffStyleData";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "Index",
  metaInfo: metaInfo.Company,
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      ...companyData,
      swiperOptions: {
        speed: 3000,
        slidesPerView: 3,
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      },
      swiperOptions2: {
        grabCursor: true,
        slidesPerView: 6,
        slidesPerGroup: 6,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      activeLi: 0,
      courseStatus: 0,
      indexStaffStyle,
      staffstyleActive: "team",
      imgActive: 1,
    };
  },
  methods: {
    tabChange(val) {
      this.acivteTab = val;
    },
    staffstyleTab(tabProp) {
      this.staffstyleActive = tabProp;
      this.imgActive = 1;
    },
  },
};
</script>
<style lang="less" scoped>
video {
  width: 100%;
  height: 100%;
}
.banner {
  width: 100%;
}
.survey {
  .content {
    display: flex;
    justify-content: space-between;
    margin-top: 70px;
    line-height: 22px;
    letter-spacing: 2px;
    padding-bottom: 68px;
    .content-left {
      width: 56%;
    }
    .content-right {
      width: 42%;
      img {
        width: 100%;
        border-radius: 5px;
      }
    }
  }
}
.brand-box {
  .img {
    width: 100%;
    margin: 52px auto 0;
  }
  .img-bg {
    width: 100%;
  }
  @media screen and (max-width: 1700px) {
    .img {
      width: 80%;
      display: block;
      margin: 52px auto 0;
    }
  }
}
.culture-box {
  padding-bottom: 80px;
  background: url("~@/assets/images/company/bg_qywh.png") no-repeat;
  background-size: 100% 100%;
}
.culture {
  .content {
    display: flex;
    justify-content: space-around;
    .per {
      text-align: center;
      .icon {
        width: 97px;
        height: 97px;
        margin: 0 auto;
      }
      .title {
        font-size: 30px;
        font-weight: 500;
        line-height: 42px;
        margin-left: 22px;
      }
      .detail {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
        margin-left: 22px;
      }
    }
  }
}
.honor-box {
  padding-bottom: 80px;
  background: url("~@/assets/images/company/bg_zsb.png") no-repeat;
  background-size: 100% 100%;
}
.swiper {
  width: 100%;
  &.swiper-container {
    width: 100%;
    .swiper-slide {
      width: 100%;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
    .swiper-pagination {
      .swiper-pagination-bullet-active {
        background-color: #f29b76;
      }
    }
  }
}
.administration {
  position: relative;
  text-align: center;
  padding-bottom: 210px;
  .top {
    text-align: left;
  }
  .top-img {
    width: 88%;
  }
  .flex {
    width: 100%;
    margin: 60px auto 0;
    height: 172px;
    background: url("~@/assets/images/company/gsgl.png") no-repeat;
    background-position-x: center;
    // background-size: 100% 100%;
    li {
      width: 331px;
      height: 254px;
      padding-left: 20px;
      cursor: pointer;
      border-radius: 5px;
      background: url("~@/assets/images/company/bg_gsgl.png") no-repeat;
      img {
        width: 100px;
        margin-top: 56px;
      }
      h3 {
        margin-top: 24px;
        font-size: 24px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
    .li-active {
      background: url("~@/assets/images/company/bg_gsgl_active.png") no-repeat;
      color: #fff;
    }
    .li-one {
      position: absolute;
      top: 340px;
      left: -0.8%;
    }
    .li-two {
      position: absolute;
      top: 340px;
      left: 35.6%;
    }
    .li-three {
      position: absolute;
      top: 340px;
      left: 71%;
    }
  }
}
.course-box {
  position: relative;
  height: 892px;
  //margin-top: 106px;
  background-color: #f3f4fb;
  .course {
    // position: absolute;
    // left: 0;
    // right: 0;
    // bottom: 50px;
    #course {
      position: relative;
    }
    .course-swiper {
      .swiper-slide {
        img {
          width: 100%;
        }
      }
    }
    .swiper-container {
      padding-bottom: 100px;
      .swiper-button-prev,
      .swiper-button-next {
        width: 80px;
        height: 80px;
        top: 86%;
      }
      .swiper-button-prev.swiper-button-black,
      .swiper-container-rtl .swiper-button-next.swiper-button-black {
        background-image: url("~@/assets/images/company/left.png");
        background-size: 100%;
        left: 42%;
      }
      .swiper-button-next.swiper-button-black,
      .swiper-container-rtl .swiper-button-prev.swiper-button-black {
        background-image: url("~@/assets/images/company/right.png");
        background-size: 100%;
        right: 42%;
      }
      .swiper-button-prev.swiper-button-disabled {
        opacity: 1;
        background-image: url("~@/assets/images/company/le-disabled.png");
      }
      .swiper-button-next.swiper-button-disabled {
        opacity: 1;
        background-image: url("~@/assets/images/company/ri-disabled.png");
      }
    }
  }
  video {
    position: absolute;
    top: -5px;
  }
}
.responsibility-box {
  position: relative;
  top: -158px;
  padding-bottom: 20px;
  margin-bottom: -160px;
  background: url("~@/assets/images/company/bg_shzr.png") no-repeat;
  background-size: 100% 100%;
  .responsibility {
    height: 1370px;
    .flex {
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      height: 538px;
      .le {
        width: 53%;
        height: 86%;
        background-color: #fff;
        border-radius: 5px;
        .content {
          margin: 60px 40px;
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            .le {
              height: 32px;
              font-size: 24px;
              font-weight: 600;
              color: #cd3324;
              line-height: 32px;
            }
            .ri {
              height: 22px;
              font-weight: 500;
              color: #999999;
              line-height: 22px;
            }
          }
          a {
            display: block;
            padding: 19px 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          a:hover {
            color: #cd3324;
            font-weight: bold;
            border-bottom: 1px solid #cd3324;
          }
        }
      }
      @media screen and (min-width: 1920px) {
        .le {
          height: 100%;
        }
      }
      .ri {
        width: 45%;
        .btn-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .btn {
            width: 48%;
            height: 50px;
            line-height: 50px;
            background-color: #213145;
            border: none;
            font-size: 18px;
            font-weight: 500;
            cursor: pointer;
            border-radius: 2px;
          }
          .activeBtn,
          .btn:hover {
            background-color: #cd3324;
          }
          .btn:hover {
            background-color: #cd3324;
          }
          .btn-society {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background-color: #cd3324;
            border: none;
            font-size: 18px;
            font-weight: 500;
            cursor: pointer;
            border-radius: 2px;
          }
        }
        img {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (min-width: 1920px) {
  .administration {
    position: relative;
    text-align: center;
    padding-bottom: 210px;
    .top {
      text-align: left;
    }
    .top-img {
      width: 88%;
    }
    .flex {
      width: 100%;
      margin: 60px auto 0;
      height: 172px;
      background: url("~@/assets/images/company/gsgl.png") no-repeat;
      background-position-x: center;
      // background-size: 100% 100%;
      li {
        width: 331px;
        height: 254px;
        padding-left: 20px;
        cursor: pointer;
        background: url("~@/assets/images/company/bg_gsgl.png") no-repeat;
        img {
          width: 100px;
          margin-top: 56px;
        }
        h3 {
          margin-top: 24px;
          font-size: 24px;
          font-weight: bold;
          letter-spacing: 1px;
        }
      }
      li:hover {
        background: url("~@/assets/images/company/bg_gsgl_active.png") no-repeat;
        color: #fff;
      }
      .li-one {
        position: absolute;
        top: 340px;
        left: 7.8%;
      }
      .li-two {
        position: absolute;
        top: 340px;
        left: 37.8%;
      }
      .li-three {
        position: absolute;
        top: 340px;
        left: 67.5%;
      }
    }
  }
  .responsibility-box {
    padding-bottom: 100px;
  }
  .staffstyle_tab_content {
    height: 430px !important;
  }
}
.staff_active {
  color: #fff !important;
  background: #cd3324 !important;
}
.img_active {
  width: 48% !important;
  > .img_default {
    width: 100% !important;
    left: 0 !important;
  }
}
.staffstyle-box {
  width: 100%;
  height: 880px;
  // padding: 70px 170px;
  .staffstyle {
    height: 100%;
    padding: 80px 0;
    .staffstyle_tab {
      margin: 40px 0;
      > span {
        display: inline-block;
        width: 180px;
        height: 60px;
        color: #333;
        font-weight: bold;
        text-align: center;
        line-height: 60px;
        border-radius: 5px;
        background: #eaeaea;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .staffstyle_tab_content {
      height: 350px;
      .tab_ul {
        display: flex;
        justify-content: space-between;
        height: 100%;
        li {
          position: relative;
          width: 16%;
          margin-right: 20px;
          overflow: hidden;
          cursor: pointer;
          border-radius: 5px;
          .img_default {
            position: absolute;
            width: calc(3 * 100%);
            left: -100%;
          }
          .img_bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.1) 0%,
              rgba(0, 0, 0, 0.6) 100%
            );
            > img {
              width: 100%;
              position: absolute;
            }
            span {
              position: absolute;
              font-size: 20px;
              font-weight: bold;
              color: #fff;
              bottom: 18%;
              margin: 0 30px;
              opacity: 0.8;
              z-index: 1;
            }
          }
          .info {
            width: calc(100% - 30px);
            // height: 33%;
            height: 145px;
            position: absolute;
            bottom: 1px;
            border-radius: 0px 40px 0px 0px;
            background: linear-gradient(131deg, #e8624a 0%, #cd3324 100%)
              #cd3324;
            padding: 32px 0 32px 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .info_name {
              color: #fff;
              font-size: 28px;
            }
            .info_line {
              display: inline-block;
              width: 30px;
              height: 4px;
              background: #ffffff;
              border-radius: 3px 0px 3px 0px;
            }
            .info_glory {
              color: #fff;
              font-size: 16px;
            }
          }
        }
        li:last-child {
          margin-right: 0;
        }
      }
    }
    .look_allStyle {
      width: 100%;
      margin-top: 40px;
      text-align: center;
      > span {
        display: inline-block;
        font-size: 16px;
        color: #333;
        font-weight: bold;
        width: 188px;
        height: 58px;
        background: linear-gradient(180deg, #f1f1f1 0%, #ffffff 100%);
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 35px 35px 29px 35px;
        border: 2px solid #ffffff;
        line-height: 58px;
        cursor: pointer;
      }
    }
  }
}

/* 新增样式 */
.banner-container {
  position: relative; /* 创建定位上下文 */
  display: flex;
  margin-top: 80px; /* 根据导航栏高度设置 */
}

.banner {
  width: 100%; /* 确保图片撑满容器 */
  height: 700px;
}

.banner-text {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -0%);
  color: white;
  text-align: center;
  width: 80%; /* 控制文字区域宽度 */
  pointer-events: none; /* 允许点击穿透到图片 */
}

.banner-text * {
  pointer-events: auto; /* 恢复内容区域交互 */
}

/* 可选：文字背景半透明层 */
.banner-text::before {
  content: "";
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  bottom: 20%;
  background: rgba(0, 0, 0, 0);
  z-index: -1;
}

.company-text {
  width: 1350px;
  height: 140px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.company-title {
  text-align: left;
  width: 286px;
  height: 59px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
  font-weight: bold;
  font-size: 48px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
}

.company-sub-title {
  width: 286px;
  height: 45px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 32px;
  color: #ffffff;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 6px;
  margin-bottom: 40px;
}

.box-title {
  width: 220px;
  height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
  padding-top: 80px;
  order: 1; /* 标题排第一 */
}

.box-sub-title {
  width: 220px;
  height: 28px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
  order: 2; /* 副标题排第二 */
  margin-top: 52px; /* 控制副标题与图片间距 */
}

.white-title {
  width: 160px;
  height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 40px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  text-transform: none;
  padding-top: 80px;
  margin-bottom: 90px;
}

.black-title {
  width: 160px;
  height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 40px;
  color: #333333;
  text-align: center;
  font-style: normal;
  text-transform: none;
  padding-top: 80px;
  margin-bottom: 90px;
}

.digit-box {
  padding-bottom: 80px;
  background: url("~@/assets/images/company/jtzl_bj.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 90px;
}

.digit-per {
  text-align: center;
  margin-right: 25px;
  .icon {
    width: 100%;
    height: 100%;
  }
}

/* CSS样式 */
.donation-list {
  padding: 0;
  border-radius: 8px;
  max-width: 800px;
  //margin: 48px auto;
  margin-top: 30px;
  margin-right: 25px;
}

.donation-item {
  display: flex;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.donation-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.year {
  color: #e60020;
  font-size: 40px;
  font-weight: 700;
  min-width: 80px;
  margin-right: 30px;
  line-height: 1.3;
  margin-top: -3px;
}

.details {
  flex: 1;
}

.details p {
  color: #333;
  font-size: 15px;
  line-height: 1.5;
  position: relative;
  padding-left: 10px;
  left: -15px;
  margin-bottom: 7px;
  margin-left: 16px;
  margin-top: 6px;
}

.details p::before {
  content: "·";
  position: absolute;
  left: -10px;
  font-size: 50px;
  line-height: 1;
  top: -15px;
}

.p-content {
  width: 90vw; /* 占视口宽度的 90% */
  min-width: 300px; /* 防止过小 */
  max-width: 1330px;
}

.fuk {
  height: 1082px !important;
  margin-left: 0 !important;
}

@media screen and (min-width: 1920px) {
  .fuk {
    height: 1127px !important;
    margin-left: 0 !important;
  }
}
</style>
